import { render, staticRenderFns } from "./ExcelUploader.vue?vue&type=template&id=f23024da&scoped=true&"
import script from "./ExcelUploader.vue?vue&type=script&lang=js&"
export * from "./ExcelUploader.vue?vue&type=script&lang=js&"
import style0 from "./ExcelUploader.vue?vue&type=style&index=0&id=f23024da&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f23024da",
  null
  
)

export default component.exports